import type { ReactNode } from 'react';

interface CardHeader {
  title: string;
  meta?: string;
  action?: ReactNode;
}

interface CardProps {
  children: ReactNode;
  className?: string;
  header?: CardHeader;
  footer?: ReactNode;
}

export function Card({ children, className = '', header, footer }: CardProps) {
  return (
    <div className={`shadow-card bg-paper-hi rounded-lg overflow-hidden ${className}`}>
      {header && (
        <div className="px-5 py-4 hair-b flex items-center justify-between">
          <div>
            <h2 className="text-[15px] font-semibold">{header.title}</h2>
            {header.meta && (
              <p className="text-[12px] text-ink-4 mt-0.5">{header.meta}</p>
            )}
          </div>
          {header.action && <div>{header.action}</div>}
        </div>
      )}
      {children}
      {footer && (
        <div className="px-5 py-3 hair-t bg-wash">
          {footer}
        </div>
      )}
    </div>
  );
}
